import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { BaseWebService } from "../../shared/services/base-web.service";
import { DeviceDetectorService } from 'ngx-device-detector';
import { format } from 'libphonenumber-js';

import 'rxjs/add/observable/throw';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class SharedService {
    constructor(
        private _basewebservice: BaseWebService,
        private _deviceService:DeviceDetectorService
    ) { }

    appColorSub = new BehaviorSubject<string>(null);

    getAppColorSub(): Observable<string> {
        return this.appColorSub.asObservable();
    }

    /**
     * Service function for Treatment Group
     */
    getTreatmentGroup() {
        return this._basewebservice.request("v1/treatment_groups/", "get", )
            .map((res: any) => res)
            .catch(this.handleError);
    }

    /**
     * Service function for Treatment Category
     */
    getTreatmentListCategory() {
        return this._basewebservice.request("v1/treatment_category_list/", "get", )
            .map((res: any) => res)
            .catch(this.handleError);
    }

    /**
     * Service function for Treatment Options
     */
    getTreatmentOptions() {
        return this._basewebservice.request("v1/treatment_options/", "get", )
            .map((res: any) => res)
            .catch(this.handleError);
    }

     /**
     * Service function for Treatment Options
     */
    getTreatmentOptionsWithCustom() {
        return this._basewebservice.request("v1/treatment_options/?include_custom=" + true, "get", )
            .map((res: any) => res)
            .catch(this.handleError);
    }

    /**
   * Function for handling service call errors
   * @param  {Response|any} error contains error data
   */
    handleError(error: Response | any) {
        return Observable.throw(error);
    }

    isMobileOrTabletDevice = () =>  this._deviceService.isMobile() || this._deviceService.isTablet()

    formatPhone(phoneNumber: string, countryCode: any) {
        let formattedNo = format(phoneNumber, countryCode, 'International');

        if (['CA', 'US'].indexOf(countryCode) !== -1) {
            formattedNo = formattedNo.replace(' ', '')
            formattedNo = '+1 (' + formattedNo.slice(2,5) + ') ' + formattedNo.slice(5, 9) + '-' + formattedNo.slice(9,14)
        }
        return formattedNo;
    }

    scrollTo(el: Element): void {
        if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'end' });
        }
    }

    scrollToError(query: string): void {
        let firstElementWithError = document.querySelector(query);

        this.scrollTo(firstElementWithError);
    }
}